import React from "react";
import styles from "./assign.module.scss";

interface BranchDropdownProps {
  branch: boolean;
  index: number;
  addBranchIndex: number | null;
  addBranchValue: (option: string, index: number) => void;
  options: string[];
  dropRef: React.RefObject<HTMLElement>;
}

export const BranchDropdown: React.FC<BranchDropdownProps> = ({ branch, index, addBranchIndex, addBranchValue, options, dropRef }) => {
  if (!branch || index !== addBranchIndex) return null;

  return (
    <div className={`dropdown-menu ${styles.dropdown_align_add} show`} ref={dropRef as React.RefObject<HTMLDivElement>}>
      {options.map((option, i) => (
        <p key={i} className={styles.dropdown_heading_add} onClick={() => addBranchValue(option, index)}>
          {option}
        </p>
      ))}
    </div>
  );
};
